import * as React from 'react';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import { ISortIcon } from '../../constants';
import FAIcon from '../fAIcon/FAIcon';
import './SortableTh.css'

export interface IThConfig {
    name: string; // name of the column like 'Kursanbieter'
    sortField?: string; // the field to sort by like 'courseProviderId'
    width: string; // like '5%'
}

export interface IThProps {
    index: number;
    onClickSorting?: (sortField: string, index: number, sortIcon: ISortIcon) => void;
    name: string;
    widthStyle?: string;
    sortIcon: ISortIcon;
    sortField?: string;
}

export const SortableTh = (props: IThProps) => {

    const icon = props.name !== '' && props.sortIcon === 0 ? (
        <FAIcon mouseHover="sortieren " icon="sort" />
    ) : props.name !== '' && props.sortIcon === 1 ? (
        <FAIcon mouseHover="sortieren nach desc" icon="sort-up" />
    ) : props.name !== '' && props.sortIcon === 2 ? (
        <FAIcon mouseHover="sortieren nach asc" icon="sort-down" />
    ) : null;

    let content;
    const sf = props.sortField;
    if( sf !== undefined) {
        content = <a onClick={() =>props.onClickSorting&& props.onClickSorting(sf, props.index, props.sortIcon)} className="sortable">{icon}{props.name}</a>
    } else {
        content = <span>{props.name}</span>
    }

    return (
        <th style={{ width: props.widthStyle }}>
            <ButtonGroup className="sortableTH">
                {content}
            </ButtonGroup>
        </th>
    );
};



// WEBPACK FOOTER //
// ./src/components/sortableTh/SortableTh.tsx